import { post, get, form } from '../axios'

const api = `${process.env.VUE_APP_COL}/customer_category/trees`

// 创建对客类目树
export function customer_category_trees_create_post(map, option) {
  return post(`${api}/create`, map, option).then(response => response)
}

// 递归删除类目节点
export function customer_category_trees_nodes_nodeId_delete_post(map, option) {
  return post(`${api}/nodes/${map.nodeId}/delete`, map, option).then(
    response => response
  )
}

// 移动并重排类目节点
export function customer_category_trees_nodes_nodeId_move_post(map, option) {
  return post(`${api}/nodes/${map.nodeId}/move`, map, option).then(
    response => response
  )
}

// 修改类目节点
export function customer_category_trees_nodes_nodeId_update_post(map, option) {
  return post(`${api}/nodes/${map.nodeId}/update`, map, option).then(
    response => response
  )
}

// 分页查询对客类目树
export function customer_category_trees_page_post(map, option) {
  return post(`${api}/page`, map, option).then(response => response)
}

// 查询对客类目树详情
export function customer_category_trees_treeId_get(map, option) {
  return get(`${api}/${map.treeId}`, map, option).then(response => response)
}

// 复制对客类目树
export function customer_category_trees_treeId_copy_post(map, option) {
  const { treeId, ...data } = map
  return post(`${api}/${treeId}/copy`, data, option).then(response => response)
}

// 删除对客类目树
export function customer_category_trees_treeId_delete_post(map, option) {
  return post(`${api}/${map.treeId}/delete`, map, option).then(
    response => response
  )
}

// 创建类目节点
export function customer_category_trees_treeId_nodes_create_post(map, option) {
  return post(`${api}/${map.treeId}/nodes/create`, map, option).then(
    response => response
  )
}

// 修改对客类目树
export function customer_category_trees_treeId_update_post(map, option) {
  return post(`${api}/${map.treeId}/update`, map, option).then(
    response => response
  )
}

// 导入并创建对客类目树
export function customer_category_trees_import_post(map, option) {
  return form(`${api}/import`, map, option).then(response => response)
}

// 下载对客类目树导入模板
export function customer_category_trees_import_template_get(map, option) {
  return get(`${api}/import-template`, map, option).then(response => response)
}

// 导出对客类目树
export function customer_category_trees_treeId_export_get(map, option) {
  const { treeId, ...params } = map
  return get(`${api}/${treeId}/export`, params, option).then(
    response => response
  )
}
